/**
 * Please add description, and a new line for every constant you declare
 */

// REDUX ACTION TYPES
// The following `increment` and `decrement` are simply examples
export const SET_INCREMENT = "SET_INCREMENT";
export const SET_DECREMENT = "SET_DECREMENT";

// User Login Related
export const SET_LOGOUT = "SET_LOGOUT";
export const SET_LOGIN = "SET_LOGIN";

// Logged-in User Detail Related
export const SET_USERNAME = "SET_USERNAME";
export const SET_PASSWORD = "SET_PASSWORD";
export const SET_USERNAME_ERROR = "SET_USERNAME_ERROR";
export const SET_PASSWORD_ERROR = "SET_PASSWORD_ERROR";

export const SET_PHONE_NUMBER = "SET_PHONE_NUMBER";
export const SET_ID = "SET_ID";
export const SET_USER_DETAILS = "SET_USER_DETAILS";

// Auth token related
export const SET_ACCESS_TOKEN = "SET_ACCESS_TOKEN";

export const clientId = process.env.NEXT_PUBLIC_CLIENT_ID;

// User Search Related
export const SET_USER_SEARCH = "SET_USER_SEARCH";
export const SET_USER_RESULT = "SET_USER_RESULT";
export const RESET_USER_SEARCH = "RESET_USER_SEARCH";

export const SET_ALERT_TYPE = "SET_ALERT_TYPE";
export const SET_ALERT_MESSAGE = "SET_ALERT_MESSAGE";
export const SET_ALERT_STATE = "SET_ALERT_STATE";

export const SET_ALL_USERS = "SET_ALL_USERS";
export const RESET_ALL_USERS = "RESET_ALL_USERS";

// Promo Code Related
export const SET_PROMO_CODES = "SET_PROMO_CODES";
export const SET_PROMO_CODES_LOADING = "SET_PROMO_CODES_LOADING";
export const SET_PROMO_CODES_ERROR = "SET_PROMO_CODES_ERROR";
export const SET_PROMO_TRANSACTIONS = "SET_PROMO_TRANSACTIONS";
export const SET_PROMO_TRANSACTIONS_LOADING = "SET_PROMO_TRANSACTIONS_LOADING";
export const RESET_PROMO_CODES = "RESET_PROMO_CODES";

// Matches and Actives Related
export const SET_MATCHES = "SET_MATCHES";
export const SET_ACTIVES = "SET_ACTIVES";
export const SET_MATCHES_ACTIVES_LOADING = "SET_MATCHES_ACTIVES_LOADING";
export const SET_MATCHES_ACTIVES_ERROR = "SET_MATCHES_ACTIVES_ERROR";
export const RESET_MATCHES_ACTIVES = "RESET_MATCHES_ACTIVES";

// RevenueCat Logs Related
export const SET_REVENUE_CAT_LOGS = "SET_REVENUE_CAT_LOGS";
export const SET_REVENUE_CAT_LOGS_LOADING = "SET_REVENUE_CAT_LOGS_LOADING";
export const SET_REVENUE_CAT_LOGS_ERROR = "SET_REVENUE_CAT_LOGS_ERROR";
export const SET_REVENUE_CAT_LOGS_PAGINATION = "SET_REVENUE_CAT_LOGS_PAGINATION";
export const SET_REVENUE_CAT_LOGS_FILTERS = "SET_REVENUE_CAT_LOGS_FILTERS";
export const RESET_REVENUE_CAT_LOGS = "RESET_REVENUE_CAT_LOGS";

// Analytics Related
export const SET_ANALYTICS_DATE_RANGE = "SET_ANALYTICS_DATE_RANGE";
export const SET_ANALYTICS_FILTERS = "SET_ANALYTICS_FILTERS";
export const SET_ANALYTICS_SUMMARY = "SET_ANALYTICS_SUMMARY";
export const SET_ANALYTICS_SUMMARY_LOADING = "SET_ANALYTICS_SUMMARY_LOADING";
export const SET_ANALYTICS_SUMMARY_ERROR = "SET_ANALYTICS_SUMMARY_ERROR";
export const SET_ANALYTICS_EVENTS = "SET_ANALYTICS_EVENTS";
export const APPEND_ANALYTICS_EVENTS = "APPEND_ANALYTICS_EVENTS";
export const SET_ANALYTICS_EVENTS_NEXT_TOKEN = "SET_ANALYTICS_EVENTS_NEXT_TOKEN";
export const SET_ANALYTICS_EVENTS_LOADING = "SET_ANALYTICS_EVENTS_LOADING";
export const SET_ANALYTICS_EVENTS_ERROR = "SET_ANALYTICS_EVENTS_ERROR";
export const SET_ANALYTICS_TOP_EVENTS = "SET_ANALYTICS_TOP_EVENTS";
export const SET_ANALYTICS_TOP_EVENTS_LOADING = "SET_ANALYTICS_TOP_EVENTS_LOADING";
export const SET_ANALYTICS_TOP_EVENTS_ERROR = "SET_ANALYTICS_TOP_EVENTS_ERROR";
export const SET_ANALYTICS_VOLUME = "SET_ANALYTICS_VOLUME";
export const SET_ANALYTICS_VOLUME_LOADING = "SET_ANALYTICS_VOLUME_LOADING";
export const SET_ANALYTICS_VOLUME_ERROR = "SET_ANALYTICS_VOLUME_ERROR";
export const SET_ANALYTICS_PLATFORM_STATS = "SET_ANALYTICS_PLATFORM_STATS";
export const SET_ANALYTICS_PLATFORM_LOADING = "SET_ANALYTICS_PLATFORM_LOADING";
export const SET_ANALYTICS_PLATFORM_ERROR = "SET_ANALYTICS_PLATFORM_ERROR";
export const SET_ANALYTICS_KNOWN_PAYLOAD_KEYS = "SET_ANALYTICS_KNOWN_PAYLOAD_KEYS";
export const SET_ANALYTICS_PAYLOAD_KEYS_LOADING = "SET_ANALYTICS_PAYLOAD_KEYS_LOADING";
export const SET_ANALYTICS_USER_FLOW = "SET_ANALYTICS_USER_FLOW";
export const APPEND_ANALYTICS_USER_FLOW = "APPEND_ANALYTICS_USER_FLOW";
export const SET_ANALYTICS_USER_FLOW_NEXT_TOKEN = "SET_ANALYTICS_USER_FLOW_NEXT_TOKEN";
export const SET_ANALYTICS_USER_FLOW_LOADING = "SET_ANALYTICS_USER_FLOW_LOADING";
export const SET_ANALYTICS_USER_FLOW_ERROR = "SET_ANALYTICS_USER_FLOW_ERROR";
export const RESET_ANALYTICS = "RESET_ANALYTICS";
